import { destinationChannel } from './destination-channel';

/**
 * What the empty Needs review list, the hints and the tour need to know about a Paige job's export
 * (CapturePoint's export scenes, da9947ea..f59d8c05, read the desktop's own export settings and
 * record instead). Paige sends every confirmed document to each of the job's destinations as soon
 * as it is packaged, and keeps every one ready to download, so its export is always "as soon as
 * ready": the questions are whether anything besides Download is set up, how many went today and
 * when the last one went (the job's card, `GET .../overview`), and how many deliveries failed for
 * good (the destinations, `GET .../destinations`).
 */
export async function fetchExportFacts(
  engineOrigin: string,
  tenant: string | undefined,
): Promise<PaigeExportFacts | null> {
  const [destinations, card] = await Promise.all([
    destinationChannel(engineOrigin, tenant).list(),
    fetch(`${engineOrigin}/overview`, {
      credentials: 'include',
      headers: tenant ? { 'Paige-Tenant': tenant } : {},
    }).then((response) => (response.ok ? (response.json() as Promise<JobCardExport>) : null)),
  ]);
  const elsewhere = destinations.filter((destination) => destination.kind !== 'download');
  return {
    destinations: elsewhere.length,
    sentToday: card?.exportedToday ?? 0,
    lastSentAt: card?.lastExportAt ?? null,
    failed: elsewhere.reduce((sum, destination) => sum + destination.failed, 0),
  };
}

/** The job card's export counts (the contract's JobCard). */
interface JobCardExport {
  exportedToday?: number;
  lastExportAt?: string | null;
}

/** A Paige job's export as the export scenes, hints and tour read it. */
export interface PaigeExportFacts {
  /** Destinations besides Download, the one every job has. */
  destinations: number;
  /** Documents delivered since the company's midnight (the job card's). */
  sentToday: number;
  lastSentAt: string | null;
  /** Deliveries that failed for good, over every destination. */
  failed: number;
}
